import React, { useState } from "react";

const WidgetFilterCheckbox = ({
  checkboxList,
  checkedObj,
  onFilterChange,
  onApplyFilter,
  onResetFilter,
}) => {
  const [moreOption, setMoreOption] = useState(false);

  if (!checkedObj) return null;

  const displayItems =
    moreOption || checkboxList.length <= 3
      ? checkboxList
      : checkboxList.slice(0, 3);

  const handleChange = (event) => {
    const [id1, key1, id2, key2] = event.target.id.split("-");
    if (key2 === "all") {
      const groupAllCheck = {};
      checkboxList
        .filter((group) => group.filter_name === key1)
        .map((filterGroup) => {
          groupAllCheck[`${id1}-${key1}`] = {};
          filterGroup.filter_options.map(
            (filter) =>
              (groupAllCheck[`${id1}-${key1}`][
                `${filter.id}-${filter.name}`
              ] = event.target.checked)
          );
        });
      const allCheck = {
        ...checkedObj,
        ...groupAllCheck,
      };
      onFilterChange(allCheck);
    } else {
      const singleCheck = {
        ...checkedObj,
        [`${id1}-${key1}`]: {
          ...checkedObj[`${id1}-${key1}`],
          [`${id2}-${key2}`]: event.target.checked,
        },
      };
      onFilterChange(singleCheck);
    }
  };

  const parentChecked = (filterGroup) => {
    const filteredGroup = filterGroup.filter_options.filter(
      (option) => option.child
    );
    const optionsChecked = filteredGroup.map(
      (option) =>
        checkedObj[`${filterGroup.id}-${filterGroup.filter_name}`][
          `${option.id}-${option.name}`
        ]
    );
    return optionsChecked.every(Boolean);
  };

  const parentIndeterminateChecked = (filterGroup) => {
    const filteredGroup = filterGroup.filter_options.filter(
      (option) => option.child
    );
    const optionsChecked = filteredGroup.map(
      (option) =>
        checkedObj[`${filterGroup.id}-${filterGroup.filter_name}`][
          `${option.id}-${option.name}`
        ]
    );

    const someChecked = optionsChecked.some(Boolean);
    const allChecked = optionsChecked.every(Boolean);

    return someChecked && !allChecked;
  };

  return (
    <div
      style={{ display: "flex", flexDirection: "column", gap: "12px" }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          maxHeight: "403px",
          overflowY: "auto",
        }}
      >
        {displayItems.map((filterGroup) => (
          <div
            key={filterGroup.id}
            style={{ display: "flex", flexDirection: "column", gap: "4px" }}
          >
            <div
              style={{
                fontSize: "12px",
                fontWeight: 400,
                color: "var(--black)",
              }}
            >
              {filterGroup.filter_display_name}
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                rowGap: "8px",
                paddingLeft: "8px",
              }}
            >
              {filterGroup.filter_options.map((filter) => {
                const isParent = filter.parent;
                const isChecked = isParent
                  ? parentChecked(filterGroup)
                  : checkedObj[`${filterGroup.id}-${filterGroup.filter_name}`][
                      `${filter.id}-${filter.name}`
                    ];
                const isIndeterminate = isParent
                  ? parentIndeterminateChecked(filterGroup)
                  : false;

                return (
                  <label
                    key={`${filterGroup.filter_name}-${filter.name}`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "var(--black)",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="checkbox"
                      id={`${filterGroup.id}-${filterGroup.filter_name}-${filter.id}-${filter.name}`}
                      checked={isChecked}
                      ref={(el) => {
                        if (el) el.indeterminate = isIndeterminate;
                      }}
                      onChange={handleChange}
                      style={{
                        marginRight: "6px",
                        accentColor: "var(--checkbox-active)",
                      }}
                    />
                    {filter.display_name}
                  </label>
                );
              })}
            </div>
          </div>
        ))}

        <div>
          <button
            onClick={() => setMoreOption((prev) => !prev)}
            style={{
              border: "none",
              background: "none",
              cursor: "pointer",
              color: "var(--card-secondary-color)",
              fontSize: "12px",
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            More {moreOption ? "▲" : "▼"}
          </button>
        </div>
      </div>

      {/* Action Buttons */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "6px",
          width: "100%",
        }}
      >
        <button
          onClick={onApplyFilter}
          style={{
            borderRadius: "999px",
            maxHeight: "32px",
            border: "none",
            textTransform: "none",
            backgroundColor: "var(--primary-link-color)",
            color: "white",
            width: "100%",
            fontSize: "14px",
            padding: "7px 0 8px 0",
            cursor: "pointer",
          }}
        >
          Apply
        </button>
        <button
          onClick={onResetFilter}
          style={{
            borderRadius: "999px",
            maxHeight: "32px",
            textTransform: "none",
            backgroundColor: "transparent",
            color: "var(--secondary-btn-color)",
            border: "1px solid var(--secondary-btn-border-color)",
            width: "100%",
            fontSize: "14px",
            padding: "7px 0 8px 0",
            cursor: "pointer",
          }}
        >
          Reset
        </button>
      </div>
    </div>
  );
};

export default WidgetFilterCheckbox;
